/**
 * custom.js — Gatittostore
 *
 * CORREÇÕES IMPLEMENTADAS:
 *
 * FIX #01 — parcelamento(): função usava parsing de texto do DOM com split() fragil
 *   CAUSA: split('                  ') depende de whitespace exato no HTML
 *   MELHORIA: uso de .trim() mais robusto + proteção contra NaN
 *
 * FIX #02 — setInterval AliHunter + redirect /collections/all já estavam corretos
 *   MANTIDOS sem alteração.
 *
 * FIX #03 — $(document).ready() envolve a chamada ao parcelamento
 *   ANTES: verificava typeof $ mas não aguardava DOM ready
 *   DEPOIS: mantido com proteção adicional contra variantes undefined
 */

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  // FIX #01: parsing mais robusto usando .text() com trim() em vez de split por whitespace
  var precoText = $('.product-form__info-item .price--highlight').text().trim();
  // Remove moeda e formata para número
  var preco = parseFloat(precoText.replace('R$', '').replace(/\./g, '').replace(',', '.').trim());
  
  var compareText = $('.product-form__info-item .price--compare').text().trim();
  var compare = parseFloat(compareText.replace('R$', '').replace(/\./g, '').replace(',', '.').trim());

  // Proteção contra NaN
  if (isNaN(preco) || preco <= 0) return;

  if (!isNaN(compare) && compare > preco) {
    var precompare = (compare - preco).toFixed(2).replace('.', ',');
    $('.product-label.product-label--on-sale span').text('R$ ' + precompare);
    
    var porcent = Math.floor(((compare - preco) * 100 / compare));
    $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%');
  }
  
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}


// FIX: garante que jQuery está disponível e DOM está pronto
if (typeof $ !== 'undefined') {
  $(document).ready(function() {
    $(".block-swatch__radio").change(function () {
      setTimeout(function () { parcelamento(); }, 150);
    });
  });
}
